export default "__VITE_ASSET__BWzXclNP__"